import React from 'react'
import styled from '@emotion/styled';
import BgRippon from '../../assets/images/bg_shade.png'
import { Paper, Box } from '@mui/material';
import Footer from '../../components/commoncomponents/Footer';
import Welcomelist from '../../components/welcomecomponents/Welocmelist';


function Welcome() {
    const StyledBanner = styled('section')(({ theme }) => {
        return {
            height: '100vh',
            position: 'relative',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',

            '&::before': {
                content: '""',
                width: '80px',
                height: '100%',
                position: 'absolute',
                top: '0',
                left: '0',
                backgroundImage: `url(${BgRippon})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: '100% 70%',
                '@media screen and (max-width:600px)': {
                    backgroundImage: 'none'
                }
            }
        }
    });
    const WelcomeCard = styled(Paper)(({ theme }) => {
        return {
            boxShadow: ' 0px 2px 20px 0px #DFC6F2BF',
            borderRadius: '20px',
            // height: 'calc(100vh - 30%)',
            width: '420px',
            padding: '30px 20px',
            position: 'relative',
            marginTop: 'auto',
            '@media screen and (max-width:600px)': {
                width: '100%',
                borderRadius: '0',
                marginTop: 'unset',
                flexGrow: 1,
            },
            '&::after': {
                content: "''",
                position: 'absolute',
                width: '200px',
                height: '200px',
                borderRadius: '50%',
                backgroundColor: '#FAF4FF',
                bottom: '-150px',
                right: '-5%',
                transform: 'translateX(5%)',
                zIndex: '-1',
            }
        }
    });

    return (

        <StyledBanner>
            <WelcomeCard >

                <Welcomelist />

            </WelcomeCard>

            <Box mt={'auto'}>
                <Footer />
            </Box>

        </StyledBanner>

    )
}

export default Welcome

